export default "__VITE_ASSET__CgAqaPJC__"